import {AuthPageCard} from '@web-libs/features/auth/shared/ui/AuthPageCard';
import {useState} from 'react';
import {useTageaRouter} from '@web-libs/core/routing/application/use-tagea-router.concern';
import {useAuth} from '@web-libs/features/auth/main/application/use-auth.concern';
import {Headline} from '@web-libs/ui/ui-components/typo/headline';
import {Text} from '@web-libs/ui/ui-components/typo/text';
import {useDictionaryContext} from '@web-libs/core/internationalization/dictionary.context';
import {RegisterForm} from '@web-libs/features/auth/register/ui/register-form';
import {BottomNavigation} from '@web-libs/features/auth/shared/ui/bottom-navigation';
import {CmsCardElement} from '@web-libs/features/cms/domain/cms.types';
import {tryGetLocalizedText} from '@web-libs/features/cms/util/extraction';

export type CmsRegistrationCardProps = CmsCardElement & {enableAnonymous: boolean};

export const CmsRegistrationCard = (props: CmsRegistrationCardProps) => {
    const [success, setSuccess] = useState(false);
    const router = useTageaRouter();
    const auth = useAuth();

    const onRegisterSuccess = () => {
        setSuccess(true);
        setTimeout(() => {
                       auth.requestLogin();
                   },
                   3000);
    };

    const dict = useDictionaryContext();

    const successMessage = (<div>
        <Headline size={'sm'}>{dict.registration.forwarding.title}</Headline>
        <Text style={{marginTop: 8}} size={'sm'}> {dict.registration.forwarding.text}</Text>
    </div>);

    const registerForm = <RegisterForm onSuccess={onRegisterSuccess} foregroundColor={'onPrimary'} enableAnonymous={props.enableAnonymous}></RegisterForm>;
    const bottomNavigation = <BottomNavigation preText={dict.registration.bottomQuestion}
                                               linkText={dict.registration.toLoginButton} onClick={() => auth.requestLogin()}/>;

    const title = tryGetLocalizedText(props,
                                      'title')!;
    const description = tryGetLocalizedText(props,
                                            'text');

    return (
        <AuthPageCard color={'primary'} form={registerForm} bottomNavigation={bottomNavigation} description={description}
                      headline={title}></AuthPageCard>
    );
};
